<template>
  <product-card-box id="processing-flow" title="办理流程">
    <div class="process-list">
      <div class="process-item" v-for="(progress, index) in product.handle_process" :key="index">
        <div class="process-step"></div>
        <div class="body">
          <div class="item-title">{{progress.title}}</div>
          <div class="item-content">{{progress.content}}</div>
        </div>
      </div>
    </div>
  </product-card-box>
</template>

<script>
import ProductCardBox from './product-card-box.vue';

export default {
  name: 'processing-flow',
  components: {
    ProductCardBox,
  },
  props: {
    product: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },
};
</script>

<style scoped lang="less">
.process-list{
  position: relative;
  z-index: 1;

  .process-item{
    padding-left: 20px;
    padding-bottom: 8px;
    position: relative;
    z-index: 1;

    &::after{
      content: "";
      position: absolute;
      left: 14px;
      top: 0;
      bottom: 0;
      z-index: -1;
      width:1px;
      opacity:0.16;
      background:#599FFF;
    }
    &:first-child{
      &::after{
        top: 15px;
      }
    }
    &:last-child{
      padding-bottom: 0;
      &::after{
        height: 15px;
        bottom: auto;
      }
    }
    .process-step{
      position: absolute;
      left: 2px;
      top: 10px;
      z-index: 2;
      width: 25px;
      height: 27px;
      background: url(../../../../assets/imgs/product-detail/step-icon.png) no-repeat center / 100% 100%;
    }
    .body{
      background: linear-gradient( 270deg, #FFFFFF 0%, #FAFBFC 100%);
      border-radius:2px;
      padding: 12px 16px;
      .item-title{
        font-size: 14px;
        color: #2F333D;
        margin-bottom: 8px;
        font-weight: 600;
      }
      .item-content{
        color: #5F666E;
        font-size: 12px;
        line-height: 18px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product/product-info/components/processing-flow.vue